<template>
  <form @submit.prevent="submit()" >
    <b-row>
      <b-col sm="12" md="6">
          <label for="title" class="form-control-label">{{ $t('views.exsbbank.form.title') }}:</label>
          <input required :placeholder="$t('views.exsbbank.form.title')" v-model="item.title" type="text" class="form-control" id="title">
          <div v-if="isInvalid('title')" class="text-danger">
            {{ violations.title }}
          </div>
      </b-col>
      <b-col sm="12" md="6">
        <b-form-group>
          <label for="description">{{ $t('views.exsbbank.form.description') }}:</label>
          <input :placeholder="$t('views.exsbbank.form.description')" v-model="item.description" type="text" class="form-control" id="description" required>
          <div v-if="isInvalid('description')" class="text-danger">
            {{ violations.description }}
          </div>
        </b-form-group>
      </b-col>
    </b-row>
    <button type="button" class="btn btn-success" @click="submit()">{{ $t('buttons.submit') }}</button>
  </form>
</template>

<script>

export default {
  name: 'Form',
  props: ['values', 'initialValues', 'handleSubmit', 'violations'],
  data () {
    return {}
  },
  computed: {
    item () {
      return this.initialValues || this.values
    }
  },
  methods: {
    submit () {
      this.handleSubmit()
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>

<style scoped>

</style>
